import React, { Component } from 'react';
import Alert from 'react-bootstrap/Alert';
//import Button from 'react-bootstrap/Button';

export default class AlertComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { show: this.props.stat }
    }

    render() {
        if (this.props.stat) {
            return (
                <Alert variant="success" onClose={() => this.props.closeAlert()} dismissible>
                    <Alert.Heading>{ this.props.title }</Alert.Heading>
                    <p>
                        {this.props.children}
                    </p>
                </Alert>
            );
        }
    }
    //return <Button onClick={() => setShow(true)}>Show Alert</Button>;
}